// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:1050px){.title-list-grid{padding-left:0!important;padding-right:0!important}}.author-page .container-fluid.container-max-width{padding:0}", ""]);
// Exports
module.exports = exports;
